import React, { useEffect, useState, Fragment, useContext } from 'react';
import Layout from 'components/sales/layout/layout';
import Images from 'assets/images/imageData';
import localization from 'assets/localization/localization';
import { Link } from 'react-router-dom';
import { Button } from 'react-bootstrap';
import { BaseUrl } from 'contexts/baseUrl/baseUrl';
import CardLayout from 'components/sales/cardLayout/cardLayout';
import ModalPop from 'components/sales/modal/modal';
import CardSection from 'components/sales/cardSection/cardSectionNew';

const SetTargetDate = ({
  getTargetDataSequence,
  targetDate,
  match,
  postTargetData,
  postVerifyData,
}) => {
  const [listData, setListData] = useState();
  const stageData = {
    site_id: 0,
    stage_data: [],
  };
  const { baseUrl } = useContext(BaseUrl);
  const [formData, setFormData] = useState(stageData);
  const [isFiled, setIsFiled] = useState(false);
  const [isModal, setIsModal] = useState(false);
  const [datesData, setDatesData] = useState({});
  const [isClicked, setIsClicked] = useState(false);

  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (match.params) {
      setFormData({ ...formData, site_id: match.params.id });
    }
  }, [match.params]);

  useEffect(() => {
    if (getTargetDataSequence !== null && match.params.id)
      (async () => await getTargetDataSequence(match.params.id))();
  }, [getTargetDataSequence,match.params.id]);

  useEffect(() => {
    if (targetDate?.fetchData) {
      setListData(targetDate?.fetchData);
    }
  }, [targetDate]);

  // const handleProductData = (val) => {
  //   if (val) {
  //     setDatesData({
  //       ...datesData,
  //       [val.stageData.stage_id]: val.stageData.expected_closure_date,
  //     });

  //     if (formData.stage_data.length === 0) {
  //       formData.stage_data.push(val?.stageData);
  //       setFormData(formData);
  //     } else {
  //       const index = formData.stage_data.findIndex(
  //         (obj) => obj?.stage_id === val?.stageData.stage_id
  //       );
  //       if (index !== -1) {
  //         formData.stage_data.splice(index, 1);
  //         formData.stage_data.push(val?.stageData);
  //         setFormData(formData);
  //       } else {
  //         formData.stage_data.push(val?.stageData);
  //         setFormData(formData);
  //       }
  //     }
  //   }
  // };

  const handleProductData = (val) => {
    if (val) {
      setDatesData({
        ...datesData,
        [val.stageData.sequence_id]: val.stageData.expected_closure_date,
      });

      if (formData.stage_data.length === 0) {
        formData.stage_data.push(val?.stageData);
        setFormData(formData);
      } else {
        const index = formData.stage_data.findIndex(
          (obj) => obj?.sequence_id === val?.stageData.sequence_id
        );
        if (index !== -1) {
          formData.stage_data.splice(index, 1);
          formData.stage_data.push(val?.stageData);
          setFormData(formData);
        } else {
          formData.stage_data.push(val?.stageData);
          setFormData(formData);
        }
      }
    }
  };
  const handleSubmit = async () => {
    setIsLoading(true);
    setIsClicked(true);
    console.log(formData,'formData');
    console.log(listData,'listData');
    if (formData.stage_data.length === listData.length) {
      // console.log(formData); return false;
      setIsFiled(false);
      const res = await postTargetData(formData);
      if (res) {
        setIsModal(true);
        setIsLoading(false);
      }
    } else {
      setIsClicked(false);
      setIsFiled(true);
      return false;
    }
    setIsLoading(false);
  };

  const handleVerifySubmit = async () => {
    setIsClicked(true);
    if (match.params.id) {
      // console.log(formData); return false;
      setIsFiled(false);
      setIsLoading(true);
      const res = await postVerifyData({'site_id' : match.params.id,'comm_id' : match.params.manageId});
      if (res) {
        setIsModal(true);
        setIsLoading(false);
      }
    } else {
      setIsClicked(false);
      setIsFiled(true);
      return false;
    }
    setIsLoading(false);
  };

  const headerBtns = () => {
    return (
      <Fragment>
        <Button onClick={handleSubmit} className="btn btn-primary" disabled={isClicked}>
          {localization.submitDtl}
          <img src={Images?.ArrowRight} alt="" />
        </Button>
      </Fragment>
    );
  };
  
  const handleModalHide = () => setIsModal(false);
  return (
    <>
    {targetDate?.site_status && targetDate?.site_status == 20 ? (
      <Layout
      title={`Verification Pending`}
      className={isFiled ? 'requiredFileds' : ''}
      isGoback
      linkUrl={`${baseUrl}/site-listing`}
      isLoading={isLoading}
    >
      <div className="panel-card-listing">
      <CardSection title={`Verify Site`} key={1}>
        <h4>Please Verify Again before Operation work Start</h4>
        <Button onClick={handleVerifySubmit} className="btn btn-primary" disabled={isClicked}>
          Verify Site
          
        </Button>
        </CardSection>
      </div>
      <ModalPop
        title={localization.conf}
        show={isModal}
        handleModalHide={handleModalHide}
        keyboard
        backdrop
      >
        <div className="text-center">
          <div className="success">
            <img src={Images?.tick} alt="" />
          </div>
          <h5>{localization.saveSuccessfully}</h5>
          <Link
            to={`${baseUrl}/site-listing`}
            className="btn btn-primary mb-4"
          >
            {localization.goBack}{' '}
            <img src={Images?.ArrowRight} alt="" />
          </Link>
        </div>
      </ModalPop>
    </Layout>
    )
      :
      (
      <Layout
      title={localization.setTargetDate}
      className={isFiled ? 'requiredFileds' : ''}
      Buttons={headerBtns}
      isGoback
      linkUrl={`${baseUrl}/site-listing`}
      isLoading={isLoading}
    >
      <div className="panel-card-listing">
        {listData &&
          listData.map((item, index) => (
            <CardLayout
              key={index}
              data={item}
              handleValue={handleProductData}
              minDateIndex={datesData[item.prev_stage]}
              listData={datesData}
              count={item.sequence_id}
              itemId={item.id}
            />
          ))}
      </div>
     
      <ModalPop
        title={localization.conf}
        show={isModal}
        handleModalHide={handleModalHide}
        keyboard
        backdrop
      >
        <div className="text-center">
          <div className="success">
            <img src={Images?.tick} alt="" />
          </div>
          <h5>{localization.saveSuccessfully}</h5>
          <Link
            to={`${baseUrl}/site-stage/${match.params.id}`}
            className="btn btn-primary mb-4"
          >
            {localization.viewSiteStages}{' '}
            <img src={Images?.ArrowRight} alt="" />
          </Link>
        </div>
      </ModalPop>
    </Layout>
      )
    }
   </>
  );
};

export default SetTargetDate;
